// Will export localized date time format and later replaced the default date/time format with these.
// TODO(CGS-2623) replace default date time format with the localized date time format after
// date time util adoption has completed.
var LOCALIZED_DATE_FORMAT = 'L';
var LOCALIZED_TIME_FORMAT = 'LT';
// Default date/time format follows ISO standard
var COGS_DEFAULT_DATE_FORMAT = 'YYYY/MM/DD';
var COGS_DEFAULT_TIME_FORMAT = 'H:mm';

export { COGS_DEFAULT_DATE_FORMAT, COGS_DEFAULT_TIME_FORMAT, LOCALIZED_DATE_FORMAT, LOCALIZED_TIME_FORMAT };
